import { FC } from "react";
import styles from "./vdp-disclaimer.module.scss";
import { IVDPBlockData, IVDPPageBlock, VDPBlockPosition } from "../../../types/vdp";
import VDPSection from "@/ui/page-components/vehicle-details-page/vdp-section";
import StringToHtmlTransformer from "@/ui/common-components/string-to-html-transformer";
import { getTranslationModule } from "@/utils/translations";

const VDPDisclaimer: FC<IVDPPageBlock> = ({ config, translations }) => {
  const t = getTranslationModule(translations, "common");
  return config ? (
    <VDPSection title={config.title || t("disclaimer")}>
      <StringToHtmlTransformer className={styles.content} layout={config?.text} />
    </VDPSection>
  ) : null;
};

const VDPBlockData: IVDPBlockData = {
  component: (props: IVDPPageBlock, key: any) => (
    <VDPDisclaimer
      key={key}
      config={props.config}
      siteData={props.siteData}
      pageContext={props.pageContext}
      renderingPosition={props.renderingPosition}
      vdpGlobalData={props.vdpGlobalData}
      translations={props.translations}
    />
  ),
  position: VDPBlockPosition.BOTTOM,
};

export default VDPBlockData;
